
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58 58"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.95 12.187l-.77-.77L40.084 1.321l-.002-.001-.768-.768A1.887 1.887 0 0037.985 0H8.963C7.777 0 6.5.916 6.5 2.926V56c0 .838.843 1.654 1.839 1.91.05.013.097.032.148.042.157.031.316.048.476.048h40.074c.16 0 .319-.017.475-.048.051-.01.098-.029.148-.042.997-.256 1.84-1.072 1.84-1.91V13.978c0-.765-.092-1.332-.55-1.791zM39.5 3.565L47.935 12H39.5V3.565zM8.963 56c-.071 0-.135-.025-.198-.049a.46.46 0 01-.265-.414V41h41v14.537a.46.46 0 01-.265.414c-.063.024-.127.049-.198.049H8.963zM8.5 39V2.926c0-.217.033-.926.463-.926h28.595a1.54 1.54 0 00-.058.392V14h11.609c.135 0 .264-.025.39-.058l.001.036V39h-41z"}}),_c('path',{attrs:{"d":"M19.566 45.25h5.086l-.287.219-4.799 7.205V54h6.7v-1.326h-5.073l.274-.219 4.799-7.205v-1.326h-6.7zM28.604 43.924h1.668V54h-1.668zM38.071 44.744a3.438 3.438 0 00-1.128-.615 4.067 4.067 0 00-1.271-.205h-2.898V54h1.641v-3.637h1.217c.528 0 1.012-.077 1.449-.232s.811-.374 1.121-.656c.31-.282.551-.631.725-1.046.173-.415.26-.877.26-1.388 0-.483-.103-.918-.308-1.306s-.475-.717-.808-.991zm-.622 3.329c-.101.278-.232.494-.396.649s-.344.267-.54.335a1.808 1.808 0 01-.595.103h-1.504v-3.992h1.23c.419 0 .756.066 1.012.198.255.132.453.296.595.492.141.196.234.401.28.615a2.8 2.8 0 01.068.567c.001.411-.05.755-.15 1.033zM29.5 23h2v-2h-2v-2h2v-2h-2v-2h2v-2h-2v-2h2V9h-2V7h-2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-2v2h2v2h-4v5c0 2.757 2.243 5 5 5s5-2.243 5-5v-5h-4v-2zm2 7c0 1.654-1.346 3-3 3s-3-1.346-3-3v-3h6v3z"}}),_c('path',{attrs:{"d":"M27.5 31h2a1 1 0 100-2h-2a1 1 0 100 2z"}})])
          )
        }
      }
    